import { getRequest } from "./ApiService";

// In-flight GET deduplication keyed by URL. Concurrent calls to the
// same URL share one network request and resolve with the same
// response. Cache clears the moment the request resolves (or
// rejects) — subsequent calls fire a fresh request.
//
// Intended for pages where multiple components independently fetch
// the same resource during their mount cycles (e.g. the student
// peer-review page where PeerReview, each <PeerEvaluation> child,
// and StudentResultsNotifications all GET /v2/forms/feedbacks/,
// /v2/forms/surveys/?course=, and /team/players/?team= on their own).
//
// Not a cache for repeated navigation — only dedupes while a request
// is in flight. For a time-based cache see AppGeneralInfoService.js.

const _inflight = new Map();

export function dedupedGet(url) {
  const existing = _inflight.get(url);
  if (existing) return existing;
  const promise = new Promise((resolve, reject) => {
    getRequest(url)
      .then(res => {
        _inflight.delete(url);
        resolve(res);
      })
      .catch(err => {
        _inflight.delete(url);
        reject(err);
      });
  });
  _inflight.set(url, promise);
  return promise;
}



// WEBPACK FOOTER //
// ./src/api/InFlightDedup.js